import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "@headlessui/react";
import { UserCircleIcon } from "@heroicons/react/24/outline";
import XPRSurveyLogo from "../assests/XPRSurveyGreen.png";
import { Repeat } from "lucide-react";
import surveyService from "../Services/surveyService";

export default function Header() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("JWTToken");
    const userID = parseInt(localStorage.getItem("userID"), 10);

    if (token && userID > 0) {
      surveyService.getUserDetailsCS().then((res) => {
        console.log("UserDetailsCS response:", res);
        if (res.status === "Success" && res.userDetails?.length > 0) {
          setUserDetails(res.userDetails[0]);
          setIsLoggedIn(true);
        }
      });
    }
  }, []);

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.clear();
    navigate("/");
  };

  // Use fetched userDetails, fallback to localStorage
  const UserName = userDetails?.name || localStorage.getItem("UserName");
  const ProfileImageUrl =
    userDetails?.profileImageUrl || localStorage.getItem("ProfileUrl");
  const UserRoleID = userDetails?.userRole || localStorage.getItem("RoleID");
  const UserType = userDetails?.userType || localStorage.getItem("UserType");

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="container mx-auto flex items-center justify-between px-4 py-3">
        {/* Logo */}
        <div className="flex items-center gap-6">
          <img
            src={XPRSurveyLogo}
            alt="VRSamadhan"
            className="w-28 cursor-default"
          />

          {/* Case Study - clickable */}
          <Link
            to="/survey-list"
            className="text-gray-700 hover:text-[#3bb290] font-medium"
          >
            Case Study
          </Link>
        </div>

        {/* Navigation Links */}
        <div className="hidden md:flex items-center space-x-6">
          {isLoggedIn && (
            <>
              {UserRoleID && ["3", "4", "5"].includes(UserRoleID) && (
                <>
                  <Link
                    to="/AdminPanel"
                    className="text-gray-700 hover:text-green-600 font-medium"
                  >
                    Admin Panel
                  </Link>
                  {UserRoleID === "3" && (
                    <Link
                      to="/CompanyPlans"
                      className="text-gray-700 hover:text-green-600 font-medium"
                    >
                      Company Plans
                    </Link>
                  )}
                </>
              )}
            </>
          )}
        </div>
        {/* Right Side */}
        <div className="flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="hidden md:block text-gray-600">
                Welcome, {UserName}
              </span>

              {/* Profile Dropdown */}
              <Menu as="div" className="relative">
                <Menu.Button className="focus:outline-none">
                  {ProfileImageUrl ? (
                    <img
                      src={ProfileImageUrl}
                      alt="Profile"
                      className="w-10 h-10 rounded-full border border-gray-300"
                    />
                  ) : (
                    <UserCircleIcon className="w-10 h-10 text-gray-500" />
                  )}
                </Menu.Button>

                <Menu.Items className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/Profile"
                        className={`block px-4 py-2 text-sm ${
                          active ? "bg-gray-100" : ""
                        }`}
                      >
                        Profile
                      </Link>
                    )}
                  </Menu.Item>
                  {/* Switch to case Study  */}
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={() => {
                          const token = localStorage.getItem("JWTToken");
                          if (token) {
                            window.location.href =
                              "https://xprssurvey.com/SurveyList";
                          } else {
                            alert("Please log in first");
                          }
                        }}
                        className={`w-full text-left px-4 py-2 text-sm ${
                          active ? "bg-gray-100" : ""
                        }`}
                      >
                        Switch to XPRS Survey
                      </button>
                    )}
                  </Menu.Item>
                  {UserType === "2" && (
                    <Menu.Item>
                      {({ active }) => (
                        <Link
                          to="/CompanyProfile"
                          className={`block px-4 py-2 text-sm ${
                            active ? "bg-gray-100" : ""
                          }`}
                        >
                          Company Profile
                        </Link>
                      )}
                    </Menu.Item>
                  )}
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        className={`w-full text-left px-4 py-2 text-sm ${
                          active ? "bg-gray-100" : ""
                        }`}
                      >
                        Settings
                      </button>
                    )}
                  </Menu.Item>
                  <div className="border-t my-1" />
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={handleLogout}
                        className={`w-full text-left px-4 py-2 text-sm text-red-600 ${
                          active ? "bg-gray-100" : ""
                        }`}
                      >
                        Sign Out
                      </button>
                    )}
                  </Menu.Item>
                </Menu.Items>
              </Menu>

              {/* <button
                onClick={() => {
                  const token = localStorage.getItem("JWTToken");
                  if (token) {
                    window.location.href = "https://xprssurvey.com/SurveyList";
                  } else {
                    alert("Please log in first");
                  }
                }}
                className="flex items-center gap-2 px-4 py-2 text-white bg-[#3bb290]
               rounded-lg shadow-md transition duration-200"
              >
                <Repeat className="w-5 h-5" />
                <span>Switch to Survey</span>
              </button> */}
            </>
          ) : (
            <>
              <Link
                to="/Login"
                className="text-gray-700 hover:text-green-600 font-medium"
              >
                Login
              </Link>
              <Link
                to="/SignUp"
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
              >
                Sign Up
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
